import styled from 'styled-components';

export const PageWrapper = styled.div`
  padding-bottom: 40px;
`;

export const PageBanner = styled.section`
  background: linear-gradient(135deg, #1A1A1A 0%, #0f0f1a 100%);
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  padding: 22px 24px 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;

  .page-title {
    font-size: 20px;
    font-weight: 800;
    color: #f1f5f9;
    margin-bottom: 4px;
    display: flex;
    align-items: center;
    gap: 10px;
    svg { color: #e8c05a; font-size: 20px; }
  }

  .page-sub { font-size: 12.5px; color: #6b7280; }

  .post-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 9px 18px;
    background: #9333EA;
    border: none;
    border-radius: 8px;
    color: #fff;
    font-size: 12.5px;
    font-weight: 600;
    cursor: pointer;
    font-family: inherit;
    flex-shrink: 0;
    transition: background 0.18s, transform 0.14s;
    &:hover { background: #6d28d9; transform: translateY(-1px); }
    svg { font-size: 14px; }
  }
`;

/* ── CONTROLS BAR ── */
export const ControlsBar = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 20px;
  background: #111;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  flex-wrap: wrap;

  .search-wrap {
    position: relative;
    width: 200px;
    flex-shrink: 0;

    svg {
      position: absolute;
      inset-inline-start: 10px;
      top: 50%;
      transform: translateY(-50%);
      color: #4b5563;
      font-size: 13px;
      pointer-events: none;
    }

    input {
      width: 100%;
      background: #1A1A1A;
      border: 1px solid rgba(255, 255, 255, 0.08);
      border-radius: 7px;
      padding-block: 8px;
      padding-inline-start: 32px;
      padding-inline-end: 12px;
      color: #e2e8f0;
      font-size: 12.5px;
      font-family: inherit;
      outline: none;
      transition: border-color 0.2s;
      &::placeholder { color: #4b5563; }
      &:focus { border-color: rgba(147, 51, 234, 0.5); }
    }
  }

  .filter-pills {
    display: flex;
    align-items: center;
    gap: 5px;
    flex: 1;
    overflow-x: auto;
    scrollbar-width: none;
    &::-webkit-scrollbar { display: none; }
  }

  .sort-select {
    background: #1A1A1A;
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 7px;
    padding: 8px 12px;
    color: #9ca3af;
    font-size: 12px;
    font-family: inherit;
    cursor: pointer;
    outline: none;
    flex-shrink: 0;
    transition: border-color 0.18s;
    &:focus { border-color: rgba(147, 51, 234, 0.5); color: #e2e8f0; }
    option { background: #1A1A1A; }
  }
`;

export const FilterBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 6px 13px;
  border-radius: 20px;
  border: 1px solid ${props => props.active ? '#9333EA' : 'rgba(255,255,255,0.08)'};
  background: ${props => props.active ? 'rgba(147,51,234,0.18)' : 'transparent'};
  color: ${props => props.active ? '#a78bfa' : '#6b7280'};
  font-size: 11.5px;
  font-weight: ${props => props.active ? '600' : '400'};
  cursor: pointer;
  font-family: inherit;
  white-space: nowrap;
  flex-shrink: 0;
  transition: all 0.16s;
  &:hover { border-color: rgba(147,51,234,0.4); color: #e2e8f0; }
`;

/* 6 columns, compact cards */
export const ItemsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 10px;
  padding: 14px 20px 4px;

  @media (max-width: 1100px) { grid-template-columns: repeat(5, 1fr); }
  @media (max-width: 860px)  { grid-template-columns: repeat(4, 1fr); }
  @media (max-width: 640px)  { grid-template-columns: repeat(3, 1fr); }
  @media (max-width: 420px)  { grid-template-columns: repeat(2, 1fr); }
`;

export const ItemCard = styled.div`
  background: #1A1A1A;
  border-radius: 9px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.04);
  cursor: pointer;
  transition: border-color 0.18s, transform 0.14s, box-shadow 0.18s;

  &:hover {
    border-color: rgba(232, 192, 90, 0.3);
    transform: translateY(-2px);
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.3);
  }

  /* smaller icon area */
  .item-img-wrap {
    position: relative;
    width: 100%;
    aspect-ratio: 1 / 1;
    background: #0d0d1b;
    display: flex;
    align-items: center;
    justify-content: center;
    max-height: 90px;    /* cap the height */
    overflow: hidden;

    .item-icon-fallback { font-size: 34px; color: #4b5563; }

    .item-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .type-badge {
      position: absolute;
      top: 5px;
      right: 5px;
      font-size: 9px;
      font-weight: 700;
      padding: 1px 6px;
      border-radius: 3px;
    }

    .category-badge {
      position: absolute;
      bottom: 5px;
      left: 5px;
      background: rgba(0,0,0,0.65);
      color: #9ca3af;
      font-size: 9px;
      padding: 1px 6px;
      border-radius: 3px;
    }
  }

  .item-body {
    padding: 8px 9px 9px;
  }

  .item-name {
    font-size: 11.5px;
    font-weight: 700;
    color: #f1f5f9;
    margin-bottom: 3px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .item-server {
    font-size: 10px;
    color: #4b5563;
    margin-bottom: 6px;
  }

  .item-price {
    font-size: 12px;
    font-weight: 800;
    color: #e8c05a;
    margin-bottom: 6px;
    display: flex;
    align-items: center;
    gap: 4px;
    svg { font-size: 11px; }
  }

  .seller-row {
    display: flex;
    align-items: center;
    gap: 5px;
    margin-bottom: 7px;

    img {
      width: 16px;
      height: 16px;
      border-radius: 50%;
      object-fit: cover;
    }
    .seller-name { font-size: 10px; color: #6b7280; }
  }

  .contact-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    width: 100%;
    padding: 6px;
    background: #5865f2;
    border: none;
    border-radius: 5px;
    color: #fff;
    font-size: 11px;
    font-weight: 600;
    cursor: pointer;
    font-family: inherit;
    transition: filter 0.16s;
    &:hover { filter: brightness(0.85); }
    svg { font-size: 11px; }
  }
`;

export const RequestBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 100%;
  padding: 6px;
  margin-top: 5px;
  background: #5865f2;
  border: none;
  border-radius: 5px;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  transition: filter 0.16s;
  &:hover { filter: brightness(0.9); }
  svg { font-size: 11px; }
`;

/* ── PAGINATION ── */
export const PaginationBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px 4px;
  flex-wrap: wrap;
  gap: 10px;

  .page-info {
    font-size: 12px;
    color: #6b7280;
    span { color: #9ca3af; font-weight: 600; }
  }

  .pages {
    display: flex;
    align-items: center;
    gap: 4px;
    direction: ltr;
  }
`;

export const PageBtn = styled.button`
  min-width: 32px;
  height: 32px;
  padding: 0 8px;
  border-radius: 7px;
  border: 1px solid ${props => props.active ? '#9333EA' : 'rgba(255,255,255,0.08)'};
  background: ${props => props.active ? '#9333EA' : 'transparent'};
  color: ${props => props.active ? '#fff' : '#9ca3af'};
  font-size: 12px;
  font-weight: ${props => props.active ? '700' : '400'};
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  opacity: ${props => props.disabled ? 0.3 : 1};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  font-family: inherit;
  transition: all 0.14s;
  svg { font-size: 13px; }
  &:hover:not([disabled]) {
    border-color: rgba(147,51,234,0.5);
    color: #e2e8f0;
    background: ${props => props.active ? '#9333EA' : 'rgba(147,51,234,0.1)'};
  }
`;
